import { User } from "@datadog/browser-core";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { AuthUser } from "@/auth/helpers";

const medspaIdKey = "medspa_id";

export const Datadog = {
  setUser(user: User) {
    datadogLogs.setUser(user);
    datadogRum.setUser(user);
  },

  setUserFromAuth(authUser: AuthUser) {
    const user: User = {
      id: authUser.id,
      email: authUser.email,
      name: authUser.displayName,
      role: authUser.role,
      impersonated_id: authUser.impersonatedId,
      impersonator_id: authUser.impersonatorId,
    };
    datadogLogs.setUser(user);
    datadogRum.setUser(user);
  },

  clearUser() {
    datadogLogs.clearUser();
    datadogRum.clearUser();
  },

  getMedspaId(): string | undefined {
    return datadogRum.getUser()?.medspa_id;
  },

  setMedspaId(medspaId: string) {
    datadogLogs.setUserProperty(medspaIdKey, medspaId);
    datadogRum.setUserProperty(medspaIdKey, medspaId);
  },

  clearMedspaId() {
    datadogLogs.removeUserProperty(medspaIdKey);
    datadogRum.removeUserProperty(medspaIdKey);
  },
};
